(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilters(form) {
      if (form.dataset.lbReady) return;
      form.dataset.lbReady = '1';
      var timer;
      function submit() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        }, 350);
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('input, select')) submit();
      });
      form.addEventListener('submit', function () {
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (el) {
          if (el.value === '') el.disabled = true;
        });
      });
      document.addEventListener('click', function (e) {
        Array.prototype.forEach.call(form.querySelectorAll('details[open]'), function (d) {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
    }

    var KEY = 'lb-wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (err) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) { /* storage unavailable */ }
    }
    function paintWishlist(root) {
      var list = read();
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-lb-wish]'), function (btn) {
        btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-lb-wish')) > -1 ? 'true' : 'false');
      });
    }

    function init(root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-lb-filter-form]'), initFilters);
      paintWishlist(root);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lb-wish]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-lb-wish');
      var list = read();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.push(handle);
      write(list);
      paintWishlist();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-contact-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lb-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-contact-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      Array.prototype.forEach.call(scope.querySelectorAll('form.lb-cform__form'), function (form) {
        if (form.dataset.lbReady) return;
        form.dataset.lbReady = '1';

        var alertBox = form.querySelector('[data-lb-alert]');
        if (alertBox && !(window.Shopify && window.Shopify.designMode)) {
          alertBox.scrollIntoView({ block: 'center' });
          alertBox.focus({ preventScroll: true });
        }

        form.addEventListener('submit', function () {
          var btn = form.querySelector('[data-lb-submit]');
          if (!btn || !form.checkValidity()) return;
          var label = btn.querySelector('span');
          if (label && btn.dataset.sending) label.textContent = btn.dataset.sending;
          setTimeout(function () { btn.disabled = true; }, 0);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lb-burger]');
      if (!btn) return;
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
